
  import React from "react"
  import Component from "/Users/ak1103dev/Witsawa/witsawa/src/layouts/index.js"
  import data from "/Users/ak1103dev/Witsawa/witsawa/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js